import InvestmentsReportModal from "./InvestmentsReportModal"

export default InvestmentsReportModal
